import queryString from "query-string";
import * as schemaCompanies from "~/schemas/schema.companies.jsx";
import * as schemaUsers from "~/schemas/schema.users.jsx";
import { arrayOfUsers } from "~/schemas/schema.users.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const addUser = (attributes) => {
  return {
    types: [actionTypes.ADD_USER_LOADING, actionTypes.ADD_USER_SUCCESS, actionTypes.ADD_USER_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};

export const inviteUser = (attributes) => {
  return {
    types: [actionTypes.INVITE_USER_LOADING, actionTypes.INVITE_USER_SUCCESS, actionTypes.INVITE_USER_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/invite`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      schema: arrayOfUsers,
    },
  };
};

export const createVirtualUser = (attributes) => {
  return {
    types: [
      actionTypes.CREATE_VIRTUAL_USER_LOADING,
      actionTypes.CREATE_VIRTUAL_USER_SUCCESS,
      actionTypes.CREATE_VIRTUAL_USER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/create-virtual-user`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      schema: arrayOfUsers,
    },
  };
};

export const activateVirtualUser = (userId, attributes) => {
  return {
    types: [
      actionTypes.ACTIVATE_VIRTUAL_USER_LOADING,
      actionTypes.ACTIVATE_VIRTUAL_USER_SUCCESS,
      actionTypes.ACTIVATE_VIRTUAL_USER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/activate-virtual-user`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      userId,
      attributes,
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};

export const editUser = (userId, attributes) => {
  return {
    types: [actionTypes.EDIT_USER_LOADING, actionTypes.EDIT_USER_SUCCESS, actionTypes.EDIT_USER_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      userId,
      attributes,
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};

export const submitBasicDetailsOnboarding = (attributes) => {
  return {
    types: [
      actionTypes.SUBMIT_BASIC_DETAILS_ONBOARDING_LOADING,
      actionTypes.SUBMIT_BASIC_DETAILS_ONBOARDING_SUCCESS,
      actionTypes.SUBMIT_BASIC_DETAILS_ONBOARDING_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/setup-wizard/first-step`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};

export const submitOrganizationDetailsOnboarding = (attributes) => {
  return {
    types: [
      actionTypes.SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_LOADING,
      actionTypes.SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_SUCCESS,
      actionTypes.SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/setup-wizard/second-step`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      schema: {
        user: schemaUsers.user,
        company: schemaCompanies.company,
      },
    },
  };
};

export const editVirtualUser = (userId, attributes) => {
  return {
    types: [
      actionTypes.EDIT_VIRTUAL_USER_LOADING,
      actionTypes.EDIT_VIRTUAL_USER_SUCCESS,
      actionTypes.EDIT_VIRTUAL_USER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/edit-virtual-user`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      userId,
      attributes,
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};

export const editLoggedUser = (userId, attributes) => {
  return {
    types: [
      actionTypes.EDIT_LOGGED_USER_LOADING,
      actionTypes.EDIT_LOGGED_USER_SUCCESS,
      actionTypes.EDIT_LOGGED_USER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      userId,
      attributes,
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};

export const loadUser = (userId) => {
  return {
    types: [actionTypes.FETCH_USERS_LOADING, actionTypes.FETCH_USERS_SUCCESS, actionTypes.FETCH_USERS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}`,
      }),
    payload: {
      userId,
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};

export const loadUsers = () => {
  return {
    types: [actionTypes.FETCH_USERS_LOADING, actionTypes.FETCH_USERS_SUCCESS, actionTypes.FETCH_USERS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users`,
      }),
    payload: {
      schema: schemaUsers.arrayOfUsers,
    },
  };
};

export const loadAllUsers = () => {
  return {
    types: [
      actionTypes.FETCH_ALL_USERS_LOADING,
      actionTypes.FETCH_ALL_USERS_SUCCESS,
      actionTypes.FETCH_ALL_USERS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/all`,
      }),
    payload: {
      schema: schemaUsers.arrayOfUsers,
    },
  };
};

export const loadUsersWorkweekCapacities = (userIds = []) => {
  return {
    types: [
      actionTypes.FETCH_USERS_WORKWEEK_CAPACITIES_LOADING,
      actionTypes.FETCH_USERS_WORKWEEK_CAPACITIES_SUCCESS,
      actionTypes.FETCH_USERS_WORKWEEK_CAPACITIES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/workweek${userIds.length ? "?" : ""}${queryString.stringify(
          { userIds: userIds },
          { arrayFormat: "bracket" }
        )}`,
      }),
  };
};

export const editUsersWorkweekCapacities = (timeWorkdays, weeklyWorkerCapacity, changedCapacities) => {
  return {
    types: [
      actionTypes.EDIT_USERS_WORKWEEK_CAPACITIES_LOADING,
      actionTypes.EDIT_USERS_WORKWEEK_CAPACITIES_SUCCESS,
      actionTypes.EDIT_USERS_WORKWEEK_CAPACITIES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/workweek`,
        method: `PUT`,
        body: {
          time_workdays: timeWorkdays,
          weekly_worker_capacity: weeklyWorkerCapacity,
          changed_capacities: changedCapacities,
        },
      }),
  };
};

export const markUserPolicyAccepted = () => {
  return {
    types: [
      actionTypes.UPDATE_POLICY_USER_LOADING,
      actionTypes.UPDATE_POLICY_USER_SUCCESS,
      actionTypes.UPDATE_POLICY_USER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/policy/accept`,
        method: `PUT`,
      }),
    payload: {},
  };
};

export const userCreatedFromEventStream = (data) => {
  return {
    type: actionTypes.ADD_USER_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaUsers.user,
  };
};

export const userUpdatedFromEventStream = (data) => {
  return {
    type: actionTypes.EDIT_USER_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaUsers.user,
    id: data.id,
  };
};

export const userMovedToTrashFromEventStream = (data) => {
  return {
    type: actionTypes.USER_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaUsers.user,
    id: data.id,
  };
};

export const userRestoredFromTrashFromEventStream = (data) => {
  return {
    type: actionTypes.USER_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaUsers.user,
    id: data.id,
  };
};

export const userMovedToArchiveFromEventStream = (data) => {
  return {
    type: actionTypes.MOVE_USER_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaUsers.user,
    id: data.id,
  };
};

export const userRestoredFromArchiveFromEventStream = (data) => {
  return {
    type: actionTypes.RESTORE_USER_FROM_ARCHIVE_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaUsers.user,
    id: data.id,
  };
};

export const inviteUserToProject = (projectId, role, emailAddresses, company_id) => {
  const payload = {
    project_ids: [projectId],
    role,
    email_addresses: emailAddresses,
    company_id,
  };
  return {
    types: [
      actionTypes.INVITE_USER_TO_PROJECT_LOADING,
      actionTypes.INVITE_USER_TO_PROJECT_SUCCESS,
      actionTypes.INVITE_USER_TO_PROJECT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/invite`,
        method: `POST`,
        body: payload,
      }),
    payload: {
      project_id: projectId,
      ...payload,
      schema: schemaUsers.arrayOfUsers,
    },
  };
};

export const changeUserPermissions = (userId, attributes) => {
  return {
    types: [
      actionTypes.CHANGE_USER_PERMISSIONS_LOADING,
      actionTypes.CHANGE_USER_PERMISSIONS_SUCCESS,
      actionTypes.CHANGE_USER_PERMISSIONS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/change-role`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      userId,
      attributes,
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};

export const archiveReplaceUser = (data) => {
  const { userId, userClass, replaceWithUserId } = data;
  return {
    types: [
      actionTypes.ARCHIVE_REPLACE_USER_LOADING,
      actionTypes.ARCHIVE_REPLACE_USER_SUCCESS,
      actionTypes.ARCHIVE_REPLACE_USER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/move-to-archive/${userClass}/${userId}`,
        method: `put`,
        body: {
          replace_with_user_id: replaceWithUserId,
        },
      }),
    payload: {
      userId,
      replaceWithUserId,
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};

export const removeReplaceUser = (data) => {
  const { userId, userClass, replaceWithUserId } = data;
  return {
    types: [
      actionTypes.REMOVE_REPLACE_USER_LOADING,
      actionTypes.REMOVE_REPLACE_USER_SUCCESS,
      actionTypes.REMOVE_REPLACE_USER_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/move-to-trash/${userClass}/${userId}`,
        method: `put`,
        body: {
          replace_with_user_id: replaceWithUserId,
        },
      }),
    payload: {
      userId,
      replaceWithUserId,
      schema: {
        single: schemaUsers.user,
      },
    },
  };
};
